<template>
    <LoaderCar v-if="loading" width="600px" marginTop="0"/>
    <div class="home-desktop-agence" v-else>
        <div class="greeting">
            <p class="title">Bonjour, {{this.$store.state.user.prenom}}&nbsp;!</p>
            <p class="subtitle">Voici le tableau de bord du secrétariat - {{new Date().toLocaleDateString('fr-FR', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'})}}</p>
        </div>

        <div class="warning-dossier" v-if="numbers.dossier > 0">
            <svg class="alert-icon" fill="none" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01" stroke="#d97706" stroke-width="2" stroke-linecap="round"/><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#d97706" stroke-width="1.5"/></svg>
            <span><strong>{{ numbers.dossier }} dossiers</strong> sont en attente de traitement. Pensez à les traiter</span>
        </div>

        <p class="vue">VUE D'ENSEMBLE</p>

        <div class="nav-panel">
            <div class="card-nav card-nav-dossier" @click="goToDossier">
                <div class="card-nav-header">
                    <div class="card-icon amber-light">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M3 7a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" stroke="#d97706" stroke-width="1.5"/><path d="M3 7l9 6 9-6" stroke="#d97706" stroke-width="1.5"/></svg>
                    </div>
                    <span class="card-badge amber-light amber-dark">Urgent</span>
                </div>
                <div class="card-nav-content">
                    <span class="main-number">{{ numbers.dossier }}</span>
                    <span class="name">Dossier</span>
                    <span class="sub-name">A traiter</span>
                    <span class="nav-link-card">Voir les dossiers →</span>
                </div>
            </div>

            <div class="card-nav card-nav-code" @click="goToCode">
                <div class="card-nav-header">
                    <div class="card-icon blue-light">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" stroke="#3b82f6" stroke-width="1.5"/><path d="M8 12h8M8 8h5" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </div>
                    <span class="card-badge blue-light blue-dark">Prépacode</span>
                </div>
                <div class="card-nav-content">
                    <span class="main-number">{{ numbers.code }}</span>
                    <span class="name">Code</span>
                    <span class="sub-name">Fourniture à remettre</span>
                    <span class="nav-link-card">Voir les codes →</span>
                </div>
            </div>

            <div class="card-nav card-nav-excode" @click="goToExCode">
                <div class="card-nav-header">
                    <div class="card-icon violet-light">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4" stroke="#8b5cf6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="9" stroke="#8b5cf6" stroke-width="1.5"/></svg>
                    </div>
                    <span class="card-badge violet-light violet-dark">A SAISIR</span>
                </div>
                <div class="card-nav-content">
                    <span class="main-number">{{ numbers.exCode.result }}</span>
                    <span class="name">Ex. de code</span>
                    <span class="sub-name">En attente de résultat</span>
                    <hr>
                    <div class="sub-cate">
                        <span class="sub-number">Moyenne test > 30</span> <span class="in-sub-number">{{ numbers.exCode.rdy }}</span>
                    </div>
                    <span class="nav-link-card">Voir les élèves →</span>
                </div>
            </div>

            <div class="card-nav card-nav-planning" @click="goToPlanning">
                <div class="card-nav-header">
                    <div class="card-icon green-light">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="#1a9e6e" stroke-width="1.5"/><path d="M3 10h18" stroke="#1a9e6e" stroke-width="1.5"/><path d="M8 4V2M16 4V2" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </div>
                    <span class="card-badge green-light green-dark">PLANNING</span>
                </div>
                <div class="card-nav-content">
                    <span class="name">Planning</span>
                    <hr>
                    <div class="sub-cate">
                        <span class="sub-number">Simu à pgmer</span> <span class="in-sub-number">{{ numbers.planning }}</span>
                    </div>
                    <span class="nav-link-card">Voir le planning →</span>
                </div>
            </div>

            <div class="card-nav card-nav-explanning" @click="goToExConduite">
                <div class="card-nav-header">
                    <div class="card-icon red-light">
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="7" r="4" stroke="#f43f5e" stroke-width="1.5"/><path d="M6 21c0-3.314 2.686-6 6-6s6 2.686 6 6" stroke="#f43f5e" stroke-width="1.5" stroke-linecap="round"/></svg>
                    </div>
                    <span class="card-badge red-light red-dark">Demandes</span>
                </div>
                <div class="card-nav-content">
                    <span class="main-number">{{ numbers.exConduite }}</span>
                    <span class="name">Ex. de conduite</span>
                    <span class="sub-name">Demandes en attente</span>
                    <span class="nav-link-card">Traiter les demandes →</span>
                </div>
            </div>
        </div>

        <div class="bottom-nav">
            <div class="excel">
                <p class="title-bottom">Extraction Excel</p>
                <div class="extract-list">
                    <div class="extract-item">
                        <div class="left-content-item">
                            <div class="btn-icon">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="18" height="18" rx="3" fill="#1b5e20" opacity=".12"/>
                                    <path d="M8 8l2.5 4L8 16M16 8l-2.5 4L16 16" stroke="#1b5e20" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5 12h14" stroke="#1b5e20" stroke-width="1.2" stroke-linecap="round" opacity=".4"/>
                                </svg>
                            </div>
                            <div class="extract-title">
                                <div class="main-title">Liste des paiements</div>
                                <div class="sub-title">Tous les paiements enregistrés entre 2 dates</div>
                            </div>
                        </div>

                        <button class="extract" @click="openModalListePaiements">
                            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path d="M12 3v13M6 11l6 6 6-6" stroke="#1b5e20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 20h16" stroke="#1b5e20" stroke-width="2" stroke-linecap="round"/></svg>
                            Exporter
                        </button>
                    </div>

                    <div class="extract-item">
                        <div class="left-content-item">
                            <div class="btn-icon">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="18" height="18" rx="3" fill="#1b5e20" opacity=".12"/>
                                    <path d="M8 8l2.5 4L8 16M16 8l-2.5 4L16 16" stroke="#1b5e20" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5 12h14" stroke="#1b5e20" stroke-width="1.2" stroke-linecap="round" opacity=".4"/>
                                </svg>
                            </div>
                            <div class="extract-title">
                                <div class="main-title">Liste CPF</div>
                                <div class="sub-title">Financements CPF</div>
                            </div>
                        </div>

                        <button class="extract" @click="openModalListeCpf">
                            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path d="M12 3v13M6 11l6 6 6-6" stroke="#1b5e20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 20h16" stroke="#1b5e20" stroke-width="2" stroke-linecap="round"/></svg>
                            Exporter
                        </button>
                    </div>

                    <div class="extract-item">
                        <div class="left-content-item">
                            <div class="btn-icon">
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="3" width="18" height="18" rx="3" fill="#1b5e20" opacity=".12"/>
                                    <path d="M8 8l2.5 4L8 16M16 8l-2.5 4L16 16" stroke="#1b5e20" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M5 12h14" stroke="#1b5e20" stroke-width="1.2" stroke-linecap="round" opacity=".4"/>
                                </svg>
                            </div>
                            <div class="extract-title">
                                <div class="main-title">Liste des soldes</div>
                                <div class="sub-title">Soldes élèves à date</div>
                            </div>
                        </div>

                        <button class="extract" @click="showSoldeModal = true;">
                            <svg width="13" height="13" fill="none" viewBox="0 0 24 24"><path d="M12 3v13M6 11l6 6 6-6" stroke="#1b5e20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 20h16" stroke="#1b5e20" stroke-width="2" stroke-linecap="round"/></svg>
                            Exporter
                        </button>
                    </div>

                </div>
            </div>

            <div class="other-page">
                <p class="title-bottom">Paramétrage</p>
                <div class="other-content">
                    <button @click="goToAgence">
                        <div class="other-badge-icon" style="background:#fdf2f8;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" stroke="#d946a8" stroke-width="1.5"/><polyline points="9 22 9 12 15 12 15 22" stroke="#d946a8" stroke-width="1.5"/></svg>
                        </div>
                        Agence
                    </button>
                    <button @click="goToFonctionnalite">
                        <div class="other-badge-icon" style="background:#fef3c7;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="9" stroke="#d97706" stroke-width="1.5"/><path d="M9.5 15a2.5 2.5 0 002.5 2h.5a2 2 0 000-4h-1a2 2 0 010-4h.5a2.5 2.5 0 012.5 2M12 7v1.5M12 15.5V17" stroke="#d97706" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </div>
                        Prix
                    </button>
                    <button @click="goToLieux">
                        <div class="other-badge-icon" style="background:#f5f3ff;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" stroke="#8b5cf6" stroke-width="1.5"/><circle cx="12" cy="10" r="3" stroke="#8b5cf6" stroke-width="1.5"/></svg>
                        </div>
                        Lieux
                    </button>
                    <button @click="goToTrame">
                        <div class="other-badge-icon" style="background:#fff7ed;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" stroke="#f97316" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><rect x="9" y="3" width="6" height="4" rx="1" stroke="#f97316" stroke-width="1.5"/><path d="M9 12h6M9 16h4" stroke="#f97316" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </div>
                        Trames de formation
                    </button>
                    <button @click="goToTransfert">
                        <div class="other-badge-icon" style="background:#eff6ff;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M17 3a2.83 2.83 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </div>
                        Transferts élèves
                    </button>
                </div>
            </div>

            <div class="other-page">
                <p class="title-bottom">Accès rapide</p>
                <div class="other-content">
                    <button @click="goToEleve">
                        <div class="other-badge-icon" style="background:#e8f7f1;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="#1a9e6e" stroke-width="1.5"/><path d="M3 10h18M8 4V2M16 4V2" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </div>
                        Élèves
                    </button>
                    <button @click="openModalPaiementCpf">
                        <div class="other-badge-icon" style="background:#e8f7f1;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="#1a9e6e" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </div>
                        Saisir un paiement
                    </button>
                    <button @click="goToPaiements">
                        <div class="other-badge-icon" style="background:#fef9c3;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="#ca8a04" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        </div>
                        Paiements archivés
                    </button>
                    <button @click="goToStageCode">
                        <div class="other-badge-icon" style="background:#eff6ff;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" stroke="#3b82f6" stroke-width="1.5"/><path d="M3 10h18M8 4V2M16 4V2M8 15h4" stroke="#3b82f6" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </div>
                        Stage de code
                    </button>
                    <button class="btn-urgence-aac" @click="goToUrgenceAac">
                        <div class="other-badge-icon" style="background:#fff1f2;">
                            <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01" stroke="#be123c" stroke-width="2" stroke-linecap="round"/><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" stroke="#be123c" stroke-width="1.5"/></svg>
                        </div>
                        Urgence AAC
                    </button>
                </div>
            </div>

        </div>

        <!-- DIALOG PART -->

        <Dialog v-model:visible="showModalPaiements" modal header="Liste des paiements entre deux dates données" :style="{ width: '50rem'}" :contentStyle="{ backgroundColor: '#F4F6F9' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <div class="listePaiements">
                <input  type="date" name="dateDeb" id="dateDeb" v-model="dateStartPaiement"/>
                <br>
                <br>
                <input  type="date" name="dateEnd" id="dateEnd" v-model="dateEndPaiement"/>
                <br>
                <br>
                <template v-if="this.dateStartPaiement != null">
                    <template v-if="this.dateEndPaiement != null">
                    <button @click="getListePaiements" class="btn btn-primary" style="margin-right: 1em;">Générer l'extraction</button>
                    </template>
                </template>
                
                <a :href="listPaiementsExcel" class="btn btn-primary" v-if="listPaiementsExcel != null"  download="paiements.csv" @click="this.listPaiementsExcel = null;">Liste des paiements</a>
            </div>
        </Dialog>

        <Dialog v-model:visible="showModalCpf" modal header="Liste des CPF à partir d'une date donnée" :style="{ width: '50rem' }" :contentStyle="{ backgroundColor: '#F4F6F9' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <div class="listePaiements">
                <input type="date" name="dateDeb" id="dateDeb" v-model="dateStartCpf" class="dateInput"/>
                <br>
                <br>
                <template v-if="this.dateStartCpf != null">
                    <button @click="getListeCpf" class="btn btn-primary" style="margin-right: 1em;">Générer l'extraction</button>
                </template>
                <a :href="listCpfExcel" class="btn btn-primary" v-if="listCpfExcel != null"  download="cpfs.csv" @click="this.listCpfExcel = null;">Liste des CPF</a>
            </div>
        </Dialog>

        <Dialog v-model:visible="showSoldeModal" modal header="Liste des soldes" :style="{ width: '50rem' }" :contentStyle="{ backgroundColor: '#F4F6F9' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
            <div class="listePaiements">
                <br>
                <button @click="getListeSoldes" class="btn btn-primary" style="margin-right: 1em;">Générer l'extraction</button>
                <a :href="listSoldeExcel" class="btn btn-primary" v-if="listSoldeExcel != null"  download="soldes.csv" @click="this.listSoldeExcel = null;">Liste des soldes</a>
            </div>
        </Dialog>
        <CpfModal :modalCpf="modalCpf" @closeModalPaiementCpf="closeModalPaiementCpf" v-if="modalCpf == true"/>
    </div>
</template>
<script>
import moment from "moment";
import LoaderCar from "../LoaderCar.vue";
import CpfModal from "@/components/agence/CpfModal.vue";

export default {

    components: {
        LoaderCar,
        CpfModal
    },

    data() {
        return {
            showModalPaiements: false,
            dateStartPaiement: null,
            dateEndPaiement: null,
            listPaiementsExcel: null,
            dateStartCpf: null,
            listCpfExcel: null,
            listSoldeExcel: null,
            showSoldeModal : false,
            loading: true,
            numbers : {},
            showModalCpf : false,
            modalCpf : false,
        }
    },

    mounted() {
        this.getHomeNumbers();
    },

    methods: {

        openModalPaiementCpf(){
            this.modalCpf = true;
        },

        closeModalPaiementCpf(){
            this.modalCpf = false;
        },

        goToDossier(){
            this.$router.push({ name: "AgenceDossier" });
        },

        goToCode(){
            this.$router.push({ name: "secretaireCode" });
        },

        goToPlanning(){
            this.$router.push({ name: "agence-planning" });
        },

        goToExCode(){
            this.$router.push({ name: "examCode" });
        },

        goToExConduite(){
            this.$router.push({ name: "agence-exam-conduite" });
        },

        goToEleve(){
            this.$router.push({ path: '/AgenceEleve' });
        },

        goToAgence(){
            this.$router.push({ path: '/Donnees' });
        },

        goToLieux(){
            this.$router.push({ path: '/agence/lieux' });
        },

        goToPaiements(){
            this.$router.push({ path: '/OtherPaiementDeleted' });
        },

        goToTransfert(){
            this.$router.push({ path: '/transfert/eleve' });
        },

        goToTrame(){
            this.$router.push({ name: 'trame' });
        },

        goToStageCode(){
            this.$router.push({ name: 'StageCodeAgence' });
        },

        goToUrgenceAac(){
            this.$store.commit('setSplitPage', true);
            this.$store.commit('setTitleSplit', 'RDV AAC');
            this.$router.push({ name: 'agence-planning' });
        },

        goToFonctionnalite(){
            this.$router.push({ name: 'Fonctionnalite' });
        },

        getListePaiements(){
            if(this.dateStartPaiement != null){
                window.api
                .post(
                    "/paiement/list/excel/"+this.$store.state.user.id,
                    {
                    start: moment(this.dateStartPaiement).format("YYYY-MM-DDTHH:mm:ss"),
                    end: moment(this.dateEndPaiement).format("YYYY-MM-DDTHH:mm:ss"),
                    },
                    {
                    headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                    },
                    }
                )
                .then((response) => {
                    let csv = response.data.liste;
                    window.URL = window.URL || window.webkiURL;
                    var blob = new Blob([csv]);
                    var blobURL = window.URL.createObjectURL(blob);
                    this.listPaiementsExcel = blobURL;
                    // this.dateEndPaiement = null;
                    // this.dateStartPaiement = null;
                })
                .catch((error) => {
                    console.log(error);
                });
            }else{
                alert("Veuillez selectionner une date de début");
            }
        },

        openModalListePaiements(){
            this.showModalPaiements = true;
        },

        getListeCpf(){
            window.api
            .post(
                "/paiement/cpf/list/excel/"+this.$store.state.user.id,
                {
                start: moment(this.dateStartCpf).format("YYYY-MM-DDTHH:mm:ss"),
                },
                {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
                }
            )
            .then((response) => {
                let csv = response.data.liste;
                window.URL = window.URL || window.webkiURL;
                var blob = new Blob([csv]);
                var blobURL = window.URL.createObjectURL(blob);
                this.listCpfExcel = blobURL;
                // this.dateStartCpf = null;
            })
            .catch((error) => {
                console.log(error);
            });
        },

        openModalListeCpf(){
            this.showModalCpf = true;
        },

        getListeSoldes(){
            window.api
                .get("/eleve/solde/excel/" + this.$store.state.user.id, {
                headers: {
                    Authorization: "Bearer " + this.$store.state.token,
                },
                })
                .then((response) => {
                let csv = response.data.liste;
                window.URL = window.URL || window.webkiURL;
                var blob = new Blob([csv]);
                var blobURL = window.URL.createObjectURL(blob);
                this.listSoldeExcel = blobURL;
                })
                .catch((error) => {
                console.log(error.response.data.message);
                });
        },

        getHomeNumbers(){
            window.api
                .get("/home/agence/numbers/" + this.$store.state.user.agence.id, {
                    headers: {
                        Authorization: "Bearer " + this.$store.state.token,
                    },
                })
                .then((response) => {
                    this.numbers = response.data.numbers
                    this.loading = false;
                })
                .catch((error) => {
                console.log(error.response.data.message);
                });
        }

    },
    
}
</script>
<style scoped>

    div.home-desktop-agence{
        width: 60%;
        margin: auto;
        margin-top: 3rem;
    }

    div.home-desktop-agence p.vue{
        color: #a5b2c3;
        text-align: left;
        font-weight: bold;
        font-size: 15px;
    }

    div.home-desktop-agence div.greeting p{
        text-align: left;
    }

    div.home-desktop-agence div.greeting p.title{
        font-size: 40px;
        font-weight: bold;
        margin: 0;
    }

    div.home-desktop-agence div.greeting p.subtitle{
        font-size: 17px;
        color: #64748b;
    }

    div.home-desktop-agence div.warning-dossier{
        background: #fffbeb;
        border: 1px solid #fde68a;
        border-left: 4px solid #f59e0b;
        border-radius: 16px;
        padding: 14px 20px;
        margin-top: 36px;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        gap: 12px;
        font-size: 14px;
        color: #92400e;
        animation: fadeDown .4s ease;
    }

    div.home-desktop-agence div.warning-dossier .alert-icon{ 
        width: 20px; 
        height: 20px; 
        flex-shrink: 0; 
    }

    div.home-desktop-agence div.nav-panel{
        width: 100%;
    }

    div.home-desktop-agence div.nav-panel div.card-nav{
        background-color: white;
        border: 1px solid #e2e8f0;
        border-radius: 16px;
        padding: 30px;
        width: 100%;
    }

    div.home-desktop-agence div.nav-panel div.card-nav:hover{ 
        transform: translateY(-3px); 
        box-shadow: 0 12px 32px rgba(0,0,0,.07); 
        cursor: pointer;
    }

    div.home-desktop-agence div.nav-panel div.card-nav-dossier:hover{
        border-top: 4px solid #b45309;
    }

    div.home-desktop-agence div.nav-panel div.card-nav-planning:hover{
        border-top: 4px solid #1a9e6e;
    }

    div.home-desktop-agence div.nav-panel div.card-nav-code:hover{
        border-top: 4px solid #1d4ed8;
    }

    div.home-desktop-agence div.nav-panel div.card-nav-excode:hover{
        border-top: 4px solid #7c3aed;
    }

    div.home-desktop-agence div.nav-panel div.card-nav-explanning:hover{
        border-top: 4px solid #be123c;
    }

    div.home-desktop-agence div.nav-panel div.card-nav:hover::before{ 
        opacity: 1; 
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-header{
        display: flex; 
        justify-content: space-between; 
        align-items: flex-start; 
        margin-bottom: 20px;
        background-color: white;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-header div.card-icon{
        width: 42px; 
        height: 42px; 
        border-radius: 12px; 
        display: flex; 
        align-items: center; 
        justify-content: center; 
    }

    .amber-light{
        background-color: #fef3c7;
    }

    .amber-dark{
        color: #b45309;
    }

    .blue-light{
        background-color: #eff6ff;
    }

    .blue-dark{
        color: #1d4ed8;
    }

    .red-light{
        background-color: #fff1f2;
    }

    .red-dark{
        color: #be123c;
    }

    .violet-light{
        background-color: #f5f3ff;
    }

    .violet-dark{
        color: #7c3aed;
    }

    .green-light{
        background-color: #e8f7f1;
    }

    .green-dark{
        color: #1a9e6e;
    }

    div.home-desktop-agence div.nav-panel{
        display: flex;
        gap: 20px;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-header span.card-badge{
        font-size: 10px; 
        font-weight: 600; 
        letter-spacing: .06em; 
        text-transform: uppercase; 
        padding: 4px 8px; 
        border-radius: 6px;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span{
        display: block;
        text-align: left;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span.main-number{
        font-size: 40px;
        font-weight:400;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span.name{
        font-size: 15px;
        font-weight:400;
        margin: 0;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span.sub-name{
        font-size: 12px;
        color: #6b7a90;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span.nav-link-card{
        color: #1a9e6e;
        margin-top: 1rem;
        font-size: 15px;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content div.sub-cate{
        display: flex;
        justify-content: space-between;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span.sub-number{
        font-size: 12px;
        color: #6b7a90;
    }

    div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span.in-sub-number{
        font-weight: bold
    }

    div.home-desktop-agence div.bottom-nav{
        width: 100%;
        margin-top: 1rem;
        display: flex;
        gap: 20px;
    }

    div.home-desktop-agence div.bottom-nav div.excel{
        padding: 30px;
        width: 100%;
        background-color: white;
        border: 1px solid #e6ebf2;
        border-radius: 16px;
    }

    div.home-desktop-agence div.bottom-nav div.other-page{
        padding: 30px;
        width: 100%;
        background-color: white;
        border: 1px solid #e6ebf2;
        border-radius: 16px;
    }

    div.home-desktop-agence div.bottom-nav p.title-bottom{
        font-size: 20px;
        font-weight: bold;
        text-align: left;
    }

    div.home-desktop-agence div.bottom-nav div.extract-item{
        display: flex;
        align-items: center;
        gap: 14px;
        justify-content: space-between;
        width: 100%;
        padding-bottom: 10px;
        margin-top: 10px;
        border-bottom: 1px solid #e6ebf2;
    }

    div.home-desktop-agence div.bottom-nav div.extract-item div.left-content-item{
        display: flex;
    }

    div.home-desktop-agence div.bottom-nav div.extract-list div.extract-item div.btn-icon{
        width: 40px;
        height: 40px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: #e8f5e9;
    }

    div.home-desktop-agence div.bottom-nav div.extract-list div.extract-item div.extract-title{
        text-align: left;
        margin-left: 20px;
    }

    div.home-desktop-agence div.bottom-nav div.extract-list div.extract-item div.extract-title div.main-title{
        font-weight: 600;
    }

    div.home-desktop-agence div.bottom-nav div.extract-list div.extract-item div.extract-title div.sub-title{
        font-size: 12px;
    }

    div.home-desktop-agence div.bottom-nav div.extract-list div.extract-item button{
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 7px 14px;
        background: #e8f5e9;
        color: #1b5e20;
        font-size: 12px;
        font-weight: 600;
        border-radius: 8px;
        text-decoration: none;
        border: none;
        cursor: pointer;
        white-space: nowrap;
        transition: background .15s;
        flex-shrink: 0;
    }

    div.home-desktop-agence div.bottom-nav div.extract-list div.extract-item button:hover{
        background: #c8e6c9;
    }

    div.other-page div.other-content{
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    div.other-page div.other-content button{
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px 14px;
        background: #f4f6f9;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        text-decoration: none;
        color: #1a1f2e;
        font-size: 13px;
        font-weight: 500;
        transition: all .15s;
        width: 100%;
    }

    div.other-page div.other-content button:hover{
        background: #fff;
        border-color: #1a9e6e;
        color: #1a9e6e;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(26,158,110,.1);
    }

    div.other-page div.other-content button.btn-urgence-aac{
        background: #be123c;
        border-color: #be123c;
        color: #fff;
        font-weight: 600;
    }

    div.other-page div.other-content button.btn-urgence-aac:hover{
        background: #9f1239;
        border-color: #9f1239;
        color: #fff;
        box-shadow: 0 4px 12px rgba(190,18,60,.25);
    }

    div.other-page div.other-content div.other-badge-icon{
        width: 30px;
        height: 30px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    div.listePaiements{
        padding: 30px;
        width: 100%;
        background-color: white;
        border: 1px solid #e6ebf2;
        border-radius: 16px;
        margin-top: 2rem;
    }

    div.listePaiements input{
        width: 100%;
        padding: 10px;
        border: 1px solid #e6ebf2;
        border-radius: 16px;
    }

    /* ===== RESPONSIVE ===== */

    @media (max-width: 1100px) {
        div.home-desktop-agence {
            width: 80%;
        }
    }

    @media (max-width: 820px) {
        div.home-desktop-agence {
            width: 92%;
            margin-top: 1.5rem;
        }

        div.home-desktop-agence div.greeting p.title {
            font-size: 28px;
        }

        div.home-desktop-agence div.greeting p.subtitle {
            font-size: 14px;
        }

        /* Cards nav : 2 par ligne */
        div.home-desktop-agence div.nav-panel {
            flex-wrap: wrap;
        }

        div.home-desktop-agence div.nav-panel div.card-nav {
            flex: 0 0 calc(50% - 10px);
            min-width: 0;
            padding: 20px;
        }

        /* Bottom nav : colonne */
        div.home-desktop-agence div.bottom-nav {
            flex-direction: column;
        }
    }

    @media (max-width: 540px) {
        div.home-desktop-agence {
            width: 100%;
            padding: 0 14px;
            box-sizing: border-box;
            margin-top: 1rem;
        }

        div.home-desktop-agence div.greeting p.title {
            font-size: 22px;
        }

        div.home-desktop-agence div.greeting p.subtitle {
            font-size: 13px;
        }

        /* Cards nav : 1 par ligne */
        div.home-desktop-agence div.nav-panel {
            flex-direction: column;
            gap: 12px;
        }

        div.home-desktop-agence div.nav-panel div.card-nav {
            flex: 0 0 100%;
            padding: 16px;
        }

        div.home-desktop-agence div.nav-panel div.card-nav div.card-nav-content span.main-number {
            font-size: 28px;
        }

        /* Bottom nav */
        div.home-desktop-agence div.bottom-nav {
            gap: 12px;
        }

        div.home-desktop-agence div.bottom-nav div.excel,
        div.home-desktop-agence div.bottom-nav div.other-page {
            padding: 18px;
        }

        /* Extract items en colonne si besoin */
        div.home-desktop-agence div.bottom-nav div.extract-item {
            flex-wrap: wrap;
            gap: 10px;
        }
    }






</style>